<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-format-list-checkbox"
    ></vuse-section-definition>

    <v-row class="mx-1 mt-3">
      <v-col class="mx-3" cols="3.5" sm="3.5">
        <v-text-field
          background-color="#EDF2F7"
          v-model="tag.name"
          filled
          label="Tên tag"
          @input="debounceInput"
        ></v-text-field>
      </v-col>
      <v-col cols="3.5" align="right" v-if="hasPermissions('Create tag')">
          <v-btn
              color="primary"
              align="right"
              @click="addNew"
          >
            Thêm tag
          </v-btn>
        </v-col>
       </v-row>
    <v-container fluid>
      <v-row justify="center" align="center">

        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="tagSearch"
              :page.sync="page_number"
              :items-per-page="itemsPerPage"
              class="elevation-1"
              @page-count="pageCount = $event"
          >
            <template v-slot:item.photo_url="{ item }" >  
              <img width="100" :src="item.photo_url ? item.photo_url : require('@/assets/images/bi_image.png')">
            </template>
            <template v-slot:item.description="{ item }" >
              <span v-html="item.description"></span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update tag')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)" v-if="hasPermissions('Delete tag')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { DELETE_TAG,GET_LIST_TAG_SEARCH} from "@/store/modules/tag";
import { GET_LIST_BRAND} from "@/store/modules/brand";
import {mapGetters} from "vuex";
import {debounce} from "debounce";
export default {

  data() {
    return {
      current_page: 1,
      page_number: 1,
      pageCount: 0,
      itemsPerPage: 10,
      page: "Quản lý Tag",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý sản phẩm",
          disabled: true,
        },
        {
          text: "Quản lý Tag",
          disabled: true,
        },
      ],
      tag : [{
        name : ""
      }]
      ,

      headers: [
        { text: 'ID', value: 'id' },
        {
          text: 'Hình ảnh',
          align: 'start',
          sortable: false,
          value: 'photo_url',
        },
        { text: 'Tên', value: 'name' },
        { text: 'Slug', value: 'slug' },
        { text: 'Mô tả', value: 'description' },
        { text: 'Actions', value: 'actions' },
      ],
      url : ''

    };
  },
  computed: {
    ...mapGetters({
      tags: "tags",
      brands : "brands",
      tagSearch: "tagSearch"
    }),brandSelect() {
      let arr = [...this.brands];
      arr.unshift({ id: "-1", name: "Chọn tất cả" });
      return arr;
    },
  },

  async created() {
    this.url = process.env.VUE_APP_API_URL
    this.page_number = parseInt(this.$route.query.page_current) || 1
    this.tag.name =  this.$route.query.name || ''
    let params = { name : this.tag.name};
    await this.$store.dispatch(GET_LIST_TAG_SEARCH,params);
    await this.$store.dispatch(GET_LIST_BRAND);
    
  },
  methods:{
    replaceTag() {
      this.$router.replace({
        query: {
          name: this.tag.name,
          page_current: parseInt(this.page_number),
        }
      })
    },
    debounceInput: debounce(function (e) {
      this.tag.name = e;
      this.replaceTag();
      let param = { name : this.tag.name};
      this.$store.dispatch(GET_LIST_TAG_SEARCH, param);
    }, 200),
    getItem(){
      let params = { name : this.tag.name};
      this.$store.dispatch(GET_LIST_TAG_SEARCH,params);
        
    },
    editItem(item){
      this.replaceTag();
      this.$router.push('/manage_productions/Tag/edit_tag/'+item.id)
    },
    deleteItem(item)
    {
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_TAG}`,item.id).then(data=>{
        if(data && data.status === 1) {
          let params = { name : this.tag.name};
          this.$store.dispatch(GET_LIST_TAG_SEARCH,params);
        }
      })
    },
    addNew() {
      this.$router.push('/manage_productions/Tag/addnew_tag')
    }
  }
};
</script>
